import { createTheme } from "@mui/material";
import { rootTheme } from "../../utils/theme";

export const styles = {
  outlineInput: {
    fontSize: 16,
    width: "100%",
  },
  selected: {
    backgroundColor: "rgba(4, 25, 57, 0.6)",
    color: "#0088F5",
  },
};
export const theme = createTheme({
  typography: {
    ...rootTheme.typography,
    allVariants: {
      color: "#F8FAFF",
    },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: 14,
          marginBottom: 10,
          marginTop: 10,
          wordBreak: "break-word",
          whiteSpace: "inherit",
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: "inherit",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(0, 136, 245, 0.15)",
          borderRadius: 8,
          fontSize: 14,
          height: 40,
          color: "#F8FAFF",
          ".MuiOutlinedInput-notchedOutline": {
            display: "none",
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          height: "100%",
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: 12,
          fontWeight: 600,
          color: "#F8FAFF",
        },
        secondary: {
          fontSize: 10,
          fontWeight: 400,
          color: "#F8FAFF",
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          background: 'inherit',
          border: 'none',
          boxShadow: 'none',
          outline: 'none',
          padding: 0,
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          backgroundColor: "rgba(0, 136, 245, 0.15)",
          fontSize: 14,
          color: "#F8FAFF",
        }
      }
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          padding: 0,
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        container: {
          marginLeft: 2,
          marginRight: 2,
          listStyle: 'none'
        },
        root: {
          cursor: "pointer",
          backgroundColor: "rgba(0, 136, 245, 0.15)",
          color: "#F8FAFF",
          borderRadius: 8,
          minHeight: 40,
          marginTop: 5,
          padding: 2,
          "&.Mui-disabled": {
            color: "#D4D4D8",
            background: "rgba(0, 136, 245, 0.15)",
            opacity: 0.4,
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: "#F8FAFF",
          width: "20px",
          height: "20px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#003B6A',
          padding: 20
        }
      }
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          rowGap: 0
        }
      }
    }
  },
});
